import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vileparletopunecabservice() {



  const cardData =
  {
    keyword: ' Vile Parle to Pune Cab Service',
    heading: 'Sai Trupti Cabs: Vile Parle to Pune Cab Service',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Kandivali to Pune cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs and Premium vehicles — all equipped with clean interiors and ample luggage space. Every ride is driven by a professional, background-verified chauffeur who ensures punctual pickup from Kandivali and safe, courteous service all the way to Pune. With transparent pricing, flexible one-way or round-trip booking options, and 24×7 customer support, Sai Trupti Cabs makes your travel from Kandivali to Pune convenient and affordable.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Vile Parle to Pune Cab Service",
      "description": "Reliable cab service from Vile Parle to Pune offering comfortable rides with professional drivers, well-maintained AC and non-AC vehicles, luggage assistance, flexible pickup and drop points, real-time tracking, and transparent fares. Ideal for families, tourists, corporate travelers, and daily commuters seeking a safe, timely, and hassle-free journey with multiple vehicle options for every budget and group size."
    },
    {
      "name": "Vile Parle to Pune Taxi",
      "description": "Convenient taxi service from Vile Parle to Pune featuring AC and non-AC cars, one-way and round trips, professional drivers, luggage support, flexible schedules, and real-time tracking. Perfect for tourists, corporate travelers, daily commuters, and small groups seeking smooth, safe, and comfortable rides with transparent fare options and easy booking."
    },
    {
      "name": "Vile Parle to Pune Car Hire",
      "description": "Car hire service from Vile Parle to Pune with a variety of vehicles including Sedans, SUVs, and luxury cars. Includes professional drivers, AC/non-AC options, luggage assistance, real-time tracking, flexible pickup and drop points, and transparent fares. Suitable for family trips, business travel, corporate outings, and long-distance journeys for a personalized, comfortable, and stress-free experience."
    },
    {
      "name": "Vile Parle to Pune Innova Cab",
      "description": "Book a spacious Innova cab from Vile Parle to Pune for comfortable travel for families or small groups. Features AC service, professional drivers, luggage support, real-time tracking, flexible pickup and drop locations, well-maintained vehicles, and transparent fares. Ensures a safe, smooth, and stress-free journey suitable for daily commuters, tourists, and corporate travelers."
    },
    {
      "name": "Vile Parle to Pune Ertiga Cab",
      "description": "Ertiga cab service from Vile Parle to Pune providing comfortable seating for small groups or families, AC service, luggage assistance, flexible schedules, real-time tracking, and professional drivers. Ideal for tourists, business travelers, and weekend trips, ensuring a reliable, safe, and enjoyable ride with transparent fares and well-maintained vehicles."
    },
    {
      "name": "Vile Parle to Pune Sedan Cab",
      "description": "Sedan cab service from Vile Parle to Pune offering smooth, comfortable rides for solo travelers, couples, or small families. Includes AC/non-AC options, professional drivers, luggage support, flexible pickup and drop points, real-time tracking, well-maintained cars, and transparent fares. Perfect for business commuters, tourists, and city-to-city travelers seeking a convenient and stress-free journey."
    },
    {
      "name": "Vile Parle to Pune One Way Taxi",
      "description": "Affordable one-way taxi service from Vile Parle to Pune for travelers seeking direct, efficient, and hassle-free transport. Features AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares. Suitable for business travelers, tourists, daily commuters, and individuals seeking reliable point-to-point service without delays."
    },
    {
      "name": "Vile Parle to Pune Drop Cab",
      "description": "Drop cab service from Vile Parle to Pune providing point-to-point travel with AC cars, professional drivers, luggage support, flexible pickup and drop locations, real-time tracking, well-maintained vehicles, and transparent fares. Ideal for daily commuters, corporate travelers, and tourists seeking a convenient, reliable, and comfortable ride without the stress of driving themselves."
    },
    {
      "name": "Vile Parle to Pune Luxury Cab",
      "description": "Premium luxury cab service from Vile Parle to Pune featuring high-end vehicles with AC service, professional chauffeurs, elegant interiors, luggage support, flexible schedules, real-time tracking, and transparent fares. Perfect for executives, VIP travelers, families, and couples seeking a comfortable, stylish, and top-class travel experience between Vile Parle and Pune."
    },
    {
      "name": "Vile Parle to Pune Outstation Cab",
      "description": "Outstation cab service from Vile Parle to Pune for long-distance travel with AC/non-AC options, professional drivers, luggage assistance, toll coverage, flexible schedules, online booking, well-maintained vehicles, and transparent fares. Ideal for weekend trips, corporate travel, and long-distance commuters, ensuring a safe, comfortable, and hassle-free journey with peace of mind."
    },
    {
      "name": "Affordable Vile Parle to Pune Cab",
      "description": "Budget-friendly cab service from Vile Parle to Pune offering cost-effective rides without compromising safety, comfort, or reliability. Includes AC/non-AC vehicles, professional drivers, luggage support, flexible pickup and drop locations, real-time tracking, well-maintained cars, and transparent fares. Perfect for students, families, tourists, and cost-conscious travelers seeking economical yet reliable transport."
    },
    {
      "name": "Vile Parle to Pune AC Cab",
      "description": "AC cab service from Vile Parle to Pune providing cool, comfortable, and safe rides for families, corporate travelers, tourists, and daily commuters. Features professional drivers, luggage assistance, flexible schedules, real-time tracking, well-maintained vehicles, online booking, and transparent fares, ensuring a smooth, stress-free, and enjoyable journey."
    },
    {
      "name": "Vile Parle to Pune Online Booking",
      "description": "Book your Vile Parle to Pune cab online instantly with multiple vehicle options including Sedans, SUVs, and luxury cars. Includes secure payments, real-time tracking, AC/non-AC options, professional drivers, luggage assistance, flexible pickup and drop locations, and transparent fares. Ideal for corporate travelers, tourists, and daily commuters seeking a convenient and reliable service at their fingertips."
    },
    {
      "name": "Vile Parle to Pune Travel Service",
      "description": "Comprehensive travel service from Vile Parle to Pune including one-way and round trips, drop services, and luxury options. Features AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, online booking, real-time tracking, and transparent fares. Ensures a safe, comfortable, and convenient journey for families, corporate travelers, tourists, and daily commuters seeking a complete travel solution."
    },
    {
      "name": "Vile Parle to Pune Cab Near Me",
      "description": "Find Vile Parle to Pune cabs near your location for quick, convenient, and hassle-free booking. Includes AC and non-AC vehicles, professional drivers, luggage support, real-time tracking, flexible schedules, transparent fares, well-maintained vehicles, and reliable service for daily, occasional, or emergency travel needs. Perfect for commuters, tourists, and business travelers seeking prompt local availability."
    }
  ],
  "tableData": [
    ["Vile Parle to Pune Cab Service", "Vile Parle to Pune Taxi"],
    ["Vile Parle to Pune Car Hire", "Vile Parle to Pune Innova Cab"],
    ["Vile Parle to Pune Ertiga Cab", "Vile Parle to Pune Sedan Cab"],
    ["Vile Parle to Pune One Way Taxi", "Vile Parle to Pune Drop Cab"],
    ["Vile Parle to Pune Luxury Cab", "Vile Parle to Pune Outstation Cab"],
    ["Affordable Vile Parle to Pune Cab", "Vile Parle to Pune AC Cab"],
    ["Vile Parle to Pune Online Booking", "Vile Parle to Pune Travel Service"],
    ["Vile Parle to Pune Cab Near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Vile Parle to Pune Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd provides reliable and comfortable cab services from Vile Parle (Mumbai) to Pune—ideal for business trips, airport transfers or leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one‑way fares from Vile Parle to Pune start from approx. **₹1,799** for a hatchback and around **₹2,399** for a sedan, depending on vehicle type and service inclusions. :contentReference[oaicite:turn0search1]{index=1} :contentReference[oaicite:turn0search0]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Vile Parle → Pune route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and experienced drivers are familiar with the Vile Parle to Pune route and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickup in Vile Parle (Mumbai) and drop‑off anywhere in Pune—including airports, hotels, stations or residential addresses."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and maintained to provide maximum comfort and reliability for your inter‑city trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Vile Parle to Pune cab easily via call, WhatsApp or our website—with instant confirmation and prompt vehicle dispatch."
  }
]






























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Vile Parle to Pune cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Vile Parle to Pune for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Vile Parle to Pune cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Vile Parle to Pune cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Vile Parle to Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Vile Parle to Pune trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Vile Parle to Pune for corporate or personal trips?',
    answer: 'Certainly. Our cab services cater to corporate clients, airport transfers, meetings, and personal travel from Vile Parle to Pune.',
  },
  {
    question: 'Is the Vile Parle to Pune cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Vile Parle to Pune trips to match your schedule and travel flexibility.',
  },
  {
    question: 'What are the Vile Parle to Pune cab fares?',
    answer: 'Our cab fares start from approximately ₹1,800 for sedans, ₹2,500–₹3,500 for SUVs and premium vehicles, depending on vehicle type, travel distance, and requirements.',
  },
  {
    question: 'What payment options are accepted for Vile Parle to Pune cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Vile Parle to Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Vile Parle to Pune cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Vile Parle to Pune cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshmukh',
    feedback: 'I booked a cab from Vile Parle to Pune with Sai Trupti Cabs. The ride was comfortable and the driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for our Vile Parle to Pune trip. Smooth journey and very courteous driver.',
    rating: 5,
  },
];





































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vile Parle to Pune Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Vile Parle to Pune Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/vile-parle-to-pune-cab-service"
  }
};






  return (
    <div>
      <Helmet>
  <title>Vile Parle to Pune Cab Service | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Vile Parle to Pune Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Vile Parle to Pune Cab Service, Vile Parle to Pune Taxi, Vile Parle to Pune Car Hire, Vile Parle to Pune Innova Cab, Vile Parle to Pune Ertiga Cab, Vile Parle to Pune Sedan Cab, Vile Parle to Pune One Way Taxi, Vile Parle to Pune Drop Cab, Vile Parle to Pune Luxury Cab, Vile Parle to Pune Outstation Cab, Affordable Vile Parle to Pune Cab, Vile Parle to Pune AC Cab, Vile Parle to Pune Online Booking, Vile Parle to Pune Travel Service, Vile Parle to Pune Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newkey/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vileparletopunecabservice;